import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from '../../utils/grid/Grid';
import IconText from './IconText';

const IconTextList = ({ teaser }) => (
  <Row center="sm">
    {teaser.map((teaserItem, index) => (
      <Col xs={12} sm={6} md={4} key={index}>
        <IconText {...teaserItem} />
      </Col>
    ))}
  </Row>
);

IconTextList.propTypes = {
  teaser: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default IconTextList;
